import type {Logger} from './baseLogger';
import {createConsoleLogger} from './baseLogger';

export let logger = createConsoleLogger();
export const setLogger = (newLogger: Logger) => {
    logger = newLogger;
};
